import React from 'react'
import { Card, CardContent, Typography, Box, Stack, FormControlLabel, Switch, Button, TextField } from '@mui/material'
import { QrCode as QrCodeIcon } from '@mui/icons-material'

interface AdditionalOptionsProps {
  notes: string
  onNotesChange: (value: string) => void
  zatcaReported: boolean
  onZatcaReportedChange: (checked: boolean) => void
  onQrClick?: () => void
  disabled?: boolean
}

const AdditionalOptions: React.FC<AdditionalOptionsProps> = ({
  notes,
  onNotesChange,
  zatcaReported,
  onZatcaReportedChange,
  onQrClick,
  disabled
}) => {
  return (
    <Card elevation={1}>
      <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
        <Typography variant="h6" gutterBottom color="primary">
          خيارات إضافية
        </Typography>
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, 
          gap: 2 
        }}>
          <TextField
            label="ملاحظات"
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            fullWidth
            multiline
            rows={3}
            size="small"
            disabled={!!disabled}
          />
          <Stack spacing={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={zatcaReported}
                  onChange={(e) => onZatcaReportedChange(e.target.checked)}
                  disabled={!!disabled}
                />
              }
              label="تم الإبلاغ لهيئة الزكاة والضريبة"
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                startIcon={<QrCodeIcon />}
                size="small"
                onClick={onQrClick}
                disabled={!!disabled}
              >
                QR Code
              </Button>
            </Box>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  )
}

export default AdditionalOptions
